import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'dark', // Set the theme to dark
        background: {
            default: '#212121', // Dark background color for the app
            paper: '#FFFFFF', // Dark background for Paper components like Card
        },
        text: {
            primary: '#black', // White text color in dark mode
            secondary: '#212121', // Light gray text for secondary text
        },
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)", // Subtle drop shadow
                    borderRadius: "4px", // Rounded corners for a softer look
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    border: "1px solid #43453A",
                    borderRadius: "8px", // Rounded buttons
                    textTransform: "none", // Keep button text case as typed
                    boxShadow: "0 3px 3px rgba(0, 0, 0, 0.3)",
                },
                containedPrimary: {
                    backgroundColor: "#0F1C37",
                    color: "white",
                    transition: "transform 0.2s ease-in-out",
                    "&:hover": {
                        transform: "scale(1.05)",
                        backgroundColor: "#BE2430", // Slightly darker olive on hover
                        color: "black",
                    },
                },
                containedSecondary: {
                    display: "flex", backgroundColor: "#c9c9b8", border: "1px solid #F3F4F0", borderRadius: "20px",
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    borderBottom: "1px solid #5E5E46",
                    borderRadius: "0 0 5px 5px",
                    boxShadow: "0 5px 4px rgba(0, 0, 0, 0.4)",
                    backgroundColor: "#FFFFFF",
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#a3a380',
                        },
                        '&:hover fieldset': {
                            borderColor: '#7a7a56',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#7a7a56',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        color: '#b0b0b0',
                    },
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f5f5f5',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#a3a380',
                        },
                        '&:hover fieldset': {
                            borderColor: '#7a7a56',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#7a7a56',
                        },
                    },
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                root: {
                    backgroundColor: '#f5f5f5',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#a3a380',
                        },
                        '&:hover fieldset': {
                            borderColor: '#7a7a56',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#7a7a56',
                        },
                    },
                },
                icon: {
                    color: '#7a7a56',
                },
                input: {
                    color: '#b0b0b0',
                },
                outlined: {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#a3a380',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#7a7a56',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#7a7a56',
                    },
                },
            },

        },
        MuiBox: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF', // Set the background to white (same as Paper)
                    border: '1px solid #5E5E46', // Same border color as other components like Paper
                    borderRadius: '8px', // Rounded corners to match other elements
                    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)', // Subtle shadow
                    padding: '16px', // Optional padding inside the Box
                },
            },
        },
    },


});

export default theme;
